import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { CityFilter, filterData } from 'src/app/shared/classes/filter';
import * as _ from 'underscore';
import { takeUntil } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { SortBy } from 'src/app/Enums/sortEnums';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { EditCityComponent } from '../edit-city/edit-city.component';
import { ComponentName, ModalSize, OnStatus } from 'src/app/Enums/usersFilterEnums';
import { ConfirmationModalComponent } from 'src/app/shared/components/confirmation-modal/confirmation-modal.component';
import { City } from 'src/app/shared/classes/users';
import { ToastrService } from 'ngx-toastr';
import { city } from 'src/app/shared/classes/city';
import { DataContextService } from 'src/app/shared/services/data-context.service';
import { CitiesService } from 'src/app/shared/services/cities.service';
import { ConstantsService } from 'src/app/shared/services/Constants/constants.service';
import { UsersService } from 'src/app/shared/services/users.service';
import { AuditData, AuditTrail } from 'src/app/shared/classes/AuditTrail';
import { TrackerOmnitureService } from 'src/app/shared/services/tracker-omniture.service';

@Component({
  selector: 'app-cities-table',
  templateUrl: './cities-table.component.html',
  styleUrls: ['./cities-table.component.less']
})
export class CitiesTableComponent implements OnInit {
  modalRef: BsModalRef;
  user:any;
  tableSetting: any;
  usersList: any;
  userModel: any;
  //need to remove in future
  cityList: any;
  statusList: any;
  totalCount: number;
  //rowsperpage: number = 10;
  currentIndex: number
  p: number = 1;
  //offset: any;
  errorMessage: string;
  showError: boolean;
  showNoResult: boolean = false;
  displaysort: boolean = false;
  roleArray: Array<any> = new Array();
  cityArray: Array<any> = new Array();
  statusArray: Array<any> = new Array();
  filterData = {} as filterData;
  itemsperPage: number = 10;
  userName: any;
  cityID:number;
  officeName: string;
  public cityData: city[] = [];
  CitySelected: number;
  CityName: string;
  name:string;
  DateAdded: any;
  AddedBy:any;
  DateChanged: any;
  ChangedBy: any;
  StateId: number;
  IsActive: boolean;
  CheckOutFrom: any;
  CheckOutTo: any;
  countLength: number;
  //rowsperpage:number;
  isPaginationChange: boolean = false;
  selectedCity: any;
  private service_URL: any;
  private unsubscribe$ = new Subject<void>();
  constructor(
    private _dataContextService: DataContextService,
    private userService: UsersService,
    private citiesService: CitiesService,
    private modalService: BsModalService,
    public toast: ToastrService,
    private httpClient: HttpClient,
    private trackeromnitureservice:TrackerOmnitureService
    // private authService: AuthService
    ) {
        this.filterData.page = 1;
        this.service_URL = ConstantsService;
   }
  ngOnInit() {
   
    // this.httpClient.get('https://localhost:8081/master/getCityMasterData').subscribe((res)=>{
    // console.log(res);
    // }) 

    this.citiesService.refreshPage
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe(() => {
        this.isPaginationChange = false;
        this.ResetCityObjects();
      
        this.getUsersData();
    });

    this.citiesService.refreshwithFilters
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe(() => {
        this.isPaginationChange = false;
        this.getUsersData();
    });

    this.citiesService.deleteCities
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe(() => {
     //console.log(this.cityID,this.selectedCity);
      this.DeleteAlert(this.cityID, this.selectedCity);
    });

    this.tableSetting = {
        columns: this.tableSettingColumns()
    };

     this.getUsersData();
     var username = localStorage.getItem('email');
    username = username.split('@')[0];
    this.trackeromnitureservice.trackPageloadData('city',username);
    this.trackeromnitureservice.trackPage("pageView");
  }

  //Test API
  // getCityMasterData = (user:any)=>{
  //   this.api.getCityMasterData().subscribe((response)=>{
  //   if(response){
    
  //   }
  //   });
  //   }
  
  //get the city list from api
  loadCityOptions(citydata: any) {
    this.cityList = citydata;
    this.cityArray = citydata;
    if (this.cityArray) {
      this.cityArray.forEach(item => {
        item.description = item.cityName;
      })
      // _.each(this.cityArray, function (item) {
      //     item.description = item.name;
      // })
    }
    if (CityFilter.cityList.length == 0) {
      this.cityArray.forEach(item => {
        item.isCheck = true;
      // item.isActive=true;
      })
      // _.each(this.cityArray, function (item) {
      //     item.isCheck = true;
      // })
    }
    else {

      this.cityArray.forEach(item => {
        CityFilter.cityList.forEach(item1 => {
          if (item.description == item1) {
            item.isCheck = true;
          }
        })
      })
      // _.each(this.cityArray, function (item) {
      //     _.each(OfficeFilter.cityList, function (item1) {
      //         if (item.description == item1) {
      //             item.isCheck = true;
      //         }
      //     })

      // })

    }
    this.tableSetting.columns[0].isFilterIcon = true;
  }
  loadStatusOptions(statusdata: any) {
    this.statusList = statusdata;
    this.statusArray = statusdata;
    if (this.statusArray) {
      this.statusArray.forEach(item => {
        item.description = item.name;
      })

      // _.each(this.statusArray, function (item) {
      //     item.description = item.name;
      // })
    }
    if (CityFilter.statusList.length == 0) {
      this.statusArray.forEach(item => {
        item.isCheck = item.description==='Active'?true:false;
      })
      // _.each(this.statusArray, function (item) {
      //     item.isCheck = true;
      // })
    }
    else {
      this.statusArray.forEach(item => {
        item.isCheck = false;
        CityFilter.statusList.forEach(item1 => {
          if (item.description == item1) {
            item.isCheck = true;
      // item.isActive=true;
          }
        })
      })

      // _.each(this.statusArray, function (item) {
      //     _.each(OfficeFilter.statusList, function (item1) {
      //         if (item.description == item1) {
      //             item.isCheck = true;
      //         }
      //     })
      // })
    }
    this.tableSetting.columns[2].isFilterIcon = true;
  }

  setIntialPageCount(totalrecords : number)
  {
    //this.totalCount = totalCount;
    this.isPaginationChange = true;
    if (totalrecords > this.itemsperPage) {
        this.countLength = this.itemsperPage;
    }
    else {
        this.countLength = totalrecords;
    }
  }


  deleteCity(selectedCityID: number, city: City) {

    this.cityID = selectedCityID;
    this.selectedCity = city;
    this.modalRef = this.modalService.show(ConfirmationModalComponent);

    // const modalsmWidth = ModalSize.Small;
    this.modalRef.setClass(ModalSize.Small);
    this.modalRef.content.title = 'Delete City';
    this.modalRef.content.description = 'Are you sure you want to delete <b>' + this.selectedCity.cityName + '</b>?';
    this.modalRef.content.buttonsTitle = {
      dismiss: 'Cancel',
      confirm: 'Delete',
      component: ComponentName.Cities
    }
  }

  searchCityByName(val) {
    this.isPaginationChange = false;
    this.userName = val;
    this.filterData.page = 1;
    this.getUsersData();
  }

  ////Call the API
  public getUsersData() {

    //let url = DataContextService.CONFIG_URL + DataContextService.BASE_URL + "catering/dashboard";
    //let url = "http://localhost:8081/api/city/GetAllCityDetailsByFilter";


    let data = this.PrepareUsersObj();


    this._dataContextService.postDatawithValues<any>(this.service_URL.CityDetails.GetAllCityDetailsByFilter, data)
     .pipe(takeUntil(this.unsubscribe$))
      .subscribe(res => {
       this.userModel = res;
       this.usersList = res.cities;
       // this.rowsperpage =3;
       this.totalCount = res.totalRecords;
      // this.AddedBy=res.addedBy;

      //Removes Duplicates from CityCollections
      
      const unique = [];

      const result = res.cityCollection.filter(element => {
          const isDupCity = unique.includes(element.cityName.toLowerCase());

          if(!isDupCity){
            unique.push(element.cityName.toLowerCase());
            return true;
          }
          return false;
      })
  
      this.loadCityOptions(result); 
       this.loadStatusOptions(res.statusCollection);
        if(!this.isPaginationChange){this.setIntialPageCount(this.totalCount);}
      })
  }

  checkFilterApplied(val) {
    this.isPaginationChange = false;
    if (val) {


      this.filterData.sortBy = CityFilter.sortBy;
      this.filterData.sortOrder = CityFilter.sortOrder;
      this.filterData.page = 1;
      this.p = 1;
      this.checkFilterValue();
      this.getUsersData();
    } else {
      this.usersList = [];
    }
  }

  checkFilterValue() {
    this.tableSetting.columns.forEach(item => {
      if (CityFilter.sortBy != item.sortBy) {
        item.isFilterApplied = false;
      }
    })
  }

  changeCurrentPage(event) {
    this.isPaginationChange = true;
    this.filterData.page = event.page;
    if ((this.totalCount / (this.filterData.page * this.itemsperPage) > 1)) {
        this.countLength = this.filterData.page * this.itemsperPage
    }
    else {
        this.countLength = this.totalCount;
    }
    this.getUsersData();
  }

  showEditData(selectedCityRow: any) {
    //console.log(selectedCityRow);

    this.modalRef = this.modalService.show(EditCityComponent, {
      initialState: {
        selectedCity: selectedCityRow,

      },

    });
    this.modalRef.setClass(ModalSize.Large);
  }

  PrepareUsersObj() {
  //Converting Status Filter response to Boolean 
  var sArray: Array<boolean> = new Array();
  
  CityFilter.statusList.forEach(element => {
    element === 'Active' ? sArray.push(true) : sArray.push(false);
  });

  let params = {
      
      Status: sArray,       
      // Role: OfficeFilter.roleList,
      // Office: UsersFilterService.officesList,
      city: CityFilter.cityList,
      SearchByName: this.userName,
      pageNo: this.filterData.page
  };

  return params;
}

  getUsers() {
    this.userService.getUsersData()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((data) => {
        this.usersList = data;
      //  console.log(data);
      })
  }

  ResetCityObjects() {
    CityFilter.cityList = [];
    CityFilter.statusList = [];
    this.userName = '';
    this.filterData.page = 1;
  }

    //Column settings
    tableSettingColumns() {
      return [
        {
          Id: 1,
          title: "City",
          classes: "ui_size_md",
          isSortable: true,
          isResNameSortN: true,
          sortBy: SortBy.City,
          cityDropdown: true,
          isFilterApplied: false,
          displaysort: false,
          isOnlyFilter: true,
          isFilterIcon: true
      },
      
        {
          Id: 2,
          title: "Country Name",
          classes: "ui_size_md",
          //isResNameSortN: true,
         // sortBy: SortBy.Phone,
          cityDropdown: true,
          isFilterApplied: false,
          displaysort: false,
          //isOnlyFilter: true,
          //isFilterIcon: true
        },
        {
          Id: 3,
          title: "Date Added",
          classes: "ui_size_md",
          // isResNameSortN: true,
         // sortBy: SortBy.Phone,
          isFilterApplied: false,
          displaysort: false,
          isFilterIcon: false,
        },
        {
          Id: 4,
          title: "Added By",
          classes: "ui_size_md",
          //isResNameSortN: true,
         // sortBy: SortBy.Phone,
          isFilterApplied: false,
          displaysort: false,
          isFilterIcon: false
        },
        {
          Id: 5,
          title: "Status",
          classes: "ui_size_md_small",
          isSortable: true,
          statusDropdown: true,
          //isResNameSortN: true,
          //filterWrapper: "event-type-dropdown",
          sortBy: SortBy.Status,
          isFilterApplied: false,
          displaysort: false,
          isOnlyFilter: true,
          isFilterIcon: true
        },
      ];
    }

      //Sorting popup
  showSortingPopup(obj) {

    _.each(this.tableSetting.columns, function (item) {
      if (item.Id != obj.Id) {
        item.displaysort = false;
      }
    })
    obj.displaysort = !obj.displaysort;
  }

  hideDropdowns() {
    _.each(this.tableSetting.columns, function (item) {
      item.displaysort = false;
    })
  }

  closeDropDown() {
    _.each(this.usersList, function (item) {
      item.showAssigneeDropdown = false;
      item.showStatusDropdown = false;
    })

  }

  convertToIST(date: any){
    date.setHours(date.getHours() + 5);
    date.setMinutes(date.getMinutes() + 30);
    var isodate = date.toISOString();

    return isodate;
  }

  DeleteAlert(selectedCityID: number, city:any) {
    if(city.status = false){
        this.toast.error("City was already deleted");
        return ;
    }

    let url = this.service_URL.CityDetails.DeleteCityId + '?id=' + selectedCityID;       
    // let data = {
    //   id: selectedOfficeID
    // };
        this._dataContextService.postDatawithValuesForDel<any>(url)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(res => {
            if (res=="3") {                
                //ToastrComponent.success("Successfully deleted!");                
                this.toast.error("This city refered in user");
                
            }
            else if(res=="1"){
                this.toast.error("City was deleted");
                //this.isPaginationChange = false;
                this.getUsersData();
            }
            else{
                this.toast.error("Some thing went on wrong..")
            }
            
        },
        (err) => {
          console.log(err);
        },
        () => {
          var primaryKey = this.usersList.filter((x) => {
            return x.cityID == selectedCityID
          })[0].cityName;

          var isActive = this.usersList.filter((x) => {
            return x.cityID == selectedCityID
          })[0].isActive;

          var data : AuditData = {
              changedAttribute: 'Status',
              oldValue: isActive ? 'Active' : 'Inactive',
              newValue: 'Inactive'
          }

          if(isActive){
            let auditParams = {
              actionPerformed : "Delete",
              actionPerformedOn : "City",
              changedBy : localStorage.getItem('email'),
              dateChanged : this.convertToIST(new Date()),
              primaryKey : primaryKey,
              messageText : [data]
            };
        
            this._dataContextService.postDatawithValues<any>(this.service_URL.AuditTrail.saveconfigaudittrail,auditParams)
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((res) => {
              // console.log(res);
            })
          }
        })
    }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
